import styled from 'styled-components';
import { ApIcon, ApMenu, ApMenuItem, colors } from '@alixpartners/ui-components';

export const ApMenuStyled = styled(ApMenu)`
  padding-top: 8px;
  min-width: 152px;
  height: 450px;
  background: ${colors.white};
`;

export const DimensionDropdownLabelText = styled.span`
  color: ${colors.grey8};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  letter-spacing: 0.3px;
`;

export const ApMenuItemStyled = styled(ApMenuItem)`
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 12px;
  font-size: 16px;
`;

export const MenuLabel = styled.div`
  max-width: 224px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PrevMenuLabel = styled(MenuLabel)`
  margin-left: 32px;
`;

export const CheckIcon = styled(ApIcon)`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  border-top: 1px solid ${colors.grey3};
  padding: 8px 8px 0 8px;
`;

export const NoDataWrapper = styled.div`
  padding: 8px 12px;
`;

export const MenuSectionLabel = styled.span`
  color: ${colors.green1};
  text-transform: none;
  font-size: 11px;
  margin-left: 32px;
`;

export const ItemsList = styled.div`
  max-height: 380px;
  max-width: 320px;
  overflow: auto;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
	&::-webkit-scrollbar {
		/* Safari and Chrome */
		display: none;
	}
`;
